import smCrypto from "sm-crypto";
import { createSM3Adapter } from "../index.js";

export function createSMCryptoAdapter() {
  const { sm3 } = smCrypto;
  const sm3WithHmac = (input) => sm3(input);

  sm3WithHmac.hmac = (key, message) => sm3(message, {
    key: Array.from(key),
    mode: "hmac",
  });

  return createSM3Adapter(sm3WithHmac);
}
